module.exports = __webpack_public_path__ + "static/media/mountain.4be774fb.png";